import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { useCourses } from "../hook";
import { WrapperCardCourses } from "./styled";
import { TableCourses } from "./TableCourses";

export const Courses = () => {
  const { changeModalCoursesState } = useCourses();

  return (
    <AdminMenuLayout pageDescription="Courses" title="Courses">
      <WrapperCardCourses>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalCoursesState}
            >
              Agregar nuevo curso
            </Button>
          </Col>
        </Row>
        <TableCourses />
      </WrapperCardCourses>
    </AdminMenuLayout>
  );
};
